import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

class RelatedProjects extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {}

    render() {
        let handleClickTop = this.props.handleClickTop;
        let {related_projects} = this.props;
        if(!related_projects.length) return [];
        let related_project_html = related_projects.map((item, key) => {
            return (
                <Link to={`${process.env.PUBLIC_URL}/project/${item.post_name}`} className="project-item" key={key}>
                    <figure>
                        <img src={item.thumb_image.url} alt={item.post_title} title={item.post_title}/>
                        <figcaption>
                            <h5 className="head">{item.post_title}</h5>
                            {
                                item.post_excerpt != '' &&
                                    <div className="desc">
                                        {item.post_excerpt}
                                    </div>
                            }
                        </figcaption>
                    </figure>
                </Link>
            )
        })
        return (
            <section className="section fp-auto-height">
                <div className="bg-lgrey vcenter">
                    <section className="ll__projects-grid ll__related_project">
                        <div className="main-container">
                            <h2 className="title-md">Related Projects</h2>
                            <a href="javascript:" className="btn-arw-top backToTop"  onClick={handleClickTop} >Back to top</a>
                            <div className="grid-3 mb-0">
                                {related_project_html}
                            </div>
                        </div>
                    </section>
                </div>   
            </section>
        );
    }
}

export default RelatedProjects;


// WEBPACK FOOTER //
// ./src/components/Projects/Details/RelatedProjects.js